import React from "react";
import {
    AVAILABILITY_CHOICE,
    EVENT_STATUS,
    EVENT_TYPE,
    useEventDataOfSelectedEvent,
} from "@Utils";
import { IEvent } from "@Interfaces/redux/store/IEvent";
import Merchandise from "../Merchandise";
import ScheduleDropdown from "../ScheduleDropdown";
import SlotDropdown from "../SlotDropdown";
import WorkshopSchedule from "../WorkshopSchedule";
import { IGetScheduleComponentProps } from "./IGetScheduleComponent";
import NoSlotsAvailable from "../NoSlotsAvailable";
import FlexibleQuantitySelector from "../FlexibleAppointmentQuantitySelector";
import DefaultSession from "../DefaultSession";

const GetSlotPickerComponent = ({
    isMobile,
    eventData,
    noSlotsAvailableJSX,
}: {
    isMobile: boolean;
    eventData: IEvent.IEventData;
    noSlotsAvailableJSX: JSX.Element;
}) => {
    const {
        type: eventType,
        availability_choice: availabilityChoice,
        slots,
        metadata: {
            is_flexible_scheduling: isFlexibleScheduling,
            sessions_visible_on_booking_page: sessionsLimit,
            limit_sessions: isLimitSessionsEnabled,
        },
    } = eventData;

    if (
        eventType === EVENT_TYPE.APPOINTMENTS &&
        availabilityChoice === AVAILABILITY_CHOICE.NOT_DECIDED
    ) {
        return noSlotsAvailableJSX;
    }

    /**
     * Incase of single session, we show the session without selector,
     * for multiple sessions we provide the user with a selecotr
     */
    const showDefaultSession =
        (isLimitSessionsEnabled && sessionsLimit === 1) || slots?.length === 1;
    if (showDefaultSession) return <DefaultSession />;

    if (isFlexibleScheduling) return <FlexibleQuantitySelector />;

    return <SlotDropdown isMobile={isMobile} />;
};

const GetScheduleComponent = (props: IGetScheduleComponentProps) => {
    const { eventData } = useEventDataOfSelectedEvent();
    const { type: eventType } = eventData;

    const { isMobile, disablePayment } = props;

    if (eventData.status === EVENT_STATUS.SOLD_OUT) return null;

    const noSlotsAvailableJSX = <NoSlotsAvailable {...props} />;

    if (disablePayment) {
        return noSlotsAvailableJSX;
    }

    switch (eventType) {
        case EVENT_TYPE.APPOINTMENTS:
        case EVENT_TYPE.WEBINAR: {
            return (
                <GetSlotPickerComponent
                    isMobile={isMobile}
                    eventData={eventData}
                    noSlotsAvailableJSX={noSlotsAvailableJSX}
                />
            );
        }
        case EVENT_TYPE.ONE_ON_ONE_CLASSES:
        case EVENT_TYPE.GROUP_CLASSES:
        case EVENT_TYPE.ROLLING_CLASSES:
            return <ScheduleDropdown isMobile={isMobile} />;
        case EVENT_TYPE.WORKSHOPS:
            return <WorkshopSchedule />;
        case EVENT_TYPE.MERCHANDISE:
            return <Merchandise />;
        default:
            return null;
    }
};

export default GetScheduleComponent;
